
import { defineComponent, reactive } from 'vue'

import SparkDocsAdPopupContacts from './Contacts.vue'
import SparkDocsAdPopupForm from './Form.vue'

import { createDeal } from '@/new-services/crm.service'

export default defineComponent({
    components: {
        'spark-docs-ad-popup-contacts': SparkDocsAdPopupContacts,
        'spark-docs-ad-popup-form': SparkDocsAdPopupForm,
    },
    emits: ['close'],
    setup(_, { emit }) {
        const state = reactive({
            is_loading: false,
            is_completed: false,
        })

        const onClose = () => {
            emit('close')
        }

        const onSubmit = async (payload: {
            name: string
            phone: string
            company: string | null
        }) => {
            try {
                state.is_loading = true

                await createDeal({
                    companyName: payload.company,
                    name: payload.name,
                    phoneNumber: payload.phone,
                    deal: 'Заявка на Spark Docs',
                    amoCrmPipelineId: 8,
                })

                state.is_completed = true
            } catch (error) {
                console.error(error)
            } finally {
                state.is_loading = false
            }
        }

        return {
            state,
            onClose,
            onSubmit,
        }
    },
})
